
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import CloseModal from '../CloseModal';
import RollModal from '../RollModal';
import RollHistoryModal from '../RollHistoryModal';
import SubRow from '../SubRow';
import { collectFormValues } from 'validate.js';
import "./styles.css";
import { connect, ReactReduxContext } from "react-redux";
import * as actions from "redux/actions/optionOrderActions";
import { Link as RouterLink } from "react-router-dom";
import ReferenceModal from '../ReferenceModal';
import GraphicModal from '../GraphicModal';
import ActionBtnRight from '../ActionBtnRight';
import OptionLastPrice from '../OptionLastPrice/OptionLastPrice';
import StockAvatar from 'components/StockAvatar';
import { AngleDown, Star, AngleRight, Circle,AccessTime, Trash, EllipsisH} from "theme/icon";


import { Translate, I18n } from "react-redux-i18n";
import { confirmDelete } from 'utils/confirmDialog';
import { getPortfolioRowClassName, toggleRowSelected } from 'utils/tableRowSelect';
import { getDisplayDte, getExpiryClassName } from 'utils/optionExpiry';
import { buildOptionDeleteParams } from 'utils/optionGroup';
import {
    getOptionLastPrice,
    getOrderOptionPl,
    getOrderOptionPlPercent,
    getStrategyNetLastPrice,
    formatPl,
} from 'utils/optionPl';
import moment from "moment-timezone";
//import moment from 'moment';
const stylesLocal = {
    subcell: {
        padding: "5px",
        //fontWeight: "bold",
        //color: "black"
    },
    cell: {
        padding: "5px",
        // fontWeight: "bold",
        //    color: "black"
    }
};

const useStyles = {
    avatar: {
        marginRight: '7px',
        height: 30,
        width: 30,
        flexDirection: 'row',
        position: "absolute",
        borderRadius: "5px"
    },

};

const Row = props => {
    const { className, order, ...rest } = props;

    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(false);

    const toNum = (value) => Number(value) || 0;
    const subOrders = Array.isArray(order.sub_order) ? order.sub_order : [];
    const isExpandable = Number(order.counter) > 1 || subOrders.length > 1;
    const expandableCount = isExpandable ? (subOrders.length || Number(order.counter) || 0) : 0;


    // const [openModalReference, setOpenModalReference] = useState(false);

    // const [reference, setReference] = useState("");

    const onClickDelete = (item) => {
        confirmDelete(I18n.t('delete_confirm_message'), () => {
            props.removeItem(props.token, buildOptionDeleteParams(item, props.user_id));
        });
    };

    const getPriceStock = (item) => {
        let quote = (props.stock[item.symbol] && props.stock[item.symbol].c) || item.price;
        return quote && Number(quote).toFixed(2);
    }

    //MSFT211203C00225000" ->  Ticker +  Expiration Year (YY) + month(MM) + day(DD) +   C =Calls and P = Puts + strike price * 1000 * digitis


    const getPriceOption = (item) => getOptionLastPrice(item, props.option);

    const getPriceStrategy = (rows) => getStrategyNetLastPrice(rows, props.option);

    const renderPlCell = (pl) => {
        const text = formatPl(pl);
        if (text == null) {
            return null;
        }
        return (
            <span style={{ color: pl < 0 ? 'red' : 'green', fontWeight: 'bold' }}>
                {text}
            </span>
        );
    };

    const plValue = getOrderOptionPl(order, props.option);
    const plPercent = getOrderOptionPlPercent(order, props.option);
    const lastPrice = Number(order.counter) === 1
        ? getPriceOption(order)
        : getPriceStrategy(subOrders);

    const subMenu = ()=>{

    }
    /*
        const handleSave = (item) => {
            setOpenModalReference(false);
            props.updateReference(props.token,
                {
                    option_id: item.id,
                    reference: reference,
                    symbol: item.symbol,
                    id: props.user_id,
                });
            setReference("");
        };
    
        const handleChange = (event) => {
            setReference(event.target.value);
        };
    */
    //moment.tz(order.open_at, "America/New_York").format('DD/MM/YYYY') 
    return (
        <React.Fragment>
            <tr
                className={getPortfolioRowClassName(selected)}
                key={props.key}
                onClick={(event) => toggleRowSelected(event, setSelected)}
            >
                <td >
                    <div className='symbol-cell'>
                    {
                        isExpandable ? (<span
                            size="small"
                            onClick={(event) => {
                                event.stopPropagation();
                                setOpen((prev) => !prev);
                            }}
                        >
                            <span style={{
                                "fontSize": "12px",
                                "fontWeight": "700",
                                "position": "absolute",
                                "left": "0px"
                            }}> {expandableCount}</span>
                           {open ? <AngleDown /> : <AngleRight />}
                        </span>

                        ) : (<span
                            size="small"
                        >
                            <Circle /> 
                        </span>)
                    }
                    <StockAvatar
                        className="avatar-sm"
                        item={order}
                        symbol={order.symbol}
                    />
                    <div className="symbol-meta">
                    {" "}<RouterLink 
                            to={"/stock/" + order.symbol} 
                            className="symbol-link" >
                                {order.symbol.toUpperCase()}
                        </RouterLink>
                    {
                        order.dividend === "1" && (
                        <Star className="symbol-star" />
                    )} 
                    </div>
                    </div>
                </td>
                <td style={{
                    padding: "5px",
                    fontWeight: "bold",
                }} align="center">
                    <OptionLastPrice
                        item={order}
                        optionPrice={getPriceStock(order)}
                        stockPrice={getPriceStock(order)}
                        subOrders={subOrders}
                        className="option-last-price--stock"
                    >
                        <span className="tooltip">
                            <AccessTime fontSize="small" aria-hidden="true" />
                            <span className="tooltiptext">Price delay 15min</span>
                        </span>
                    </OptionLastPrice>
                </td>

                <td style={stylesLocal.cell} align="right">
                    {order.open_at && moment(order.open_at).zone("+00:00").format('DD/MM/YYYY')}
                </td>

                <td style={stylesLocal.cell} align="right">{(isExpandable ? order.quantity : ((order.market === "SELL" ? "-" : "+") + order.quantity + (order.option_kind === "CALL" ? "C" : "P")))}</td>

                <td style={stylesLocal.cell} align="right">  {toNum(order.strike).toFixed(2)} </td>

                <td style={stylesLocal.cell} align="right">  {toNum(order.open_price).toFixed(2)}</td>

                <td style={stylesLocal.cell} align="right">  {toNum(order.open_trade).toFixed(2)}</td>

                <td style={stylesLocal.cell} align="right">  {order.market && (order.market === "SELL" ? (toNum(order.strike) - toNum(order.open_price)).toFixed(2) : (toNum(order.strike) + toNum(order.open_price)).toFixed(2))}
                </td>

                <td
                    className={getExpiryClassName(order.expire_at)}
                    style={{ padding: '5px' }}
                >
                    {order.expire_at && moment(order.expire_at).zone("+00:00").format('DD/MM/YYYY')}
                </td>

                <td
                    className={getExpiryClassName(order.expire_at)}
                    style={stylesLocal.cell}
                    align="right"
                >
                    {order.expire_at && getDisplayDte(order.expire_at)}{"d"}
                </td>

                <td style={{
                    padding: "5px",
                    fontWeight: "bold",
                    color: "black"
                }} align="right">
                    {lastPrice != null && (
                        <React.Fragment>
                            {lastPrice}
                            <span className="tooltip">
                                <AccessTime fontSize="small" aria-hidden="true" />
                                <span className="tooltiptext">Price delay 15min</span>
                            </span>
                        </React.Fragment>
                    )}
                </td>
                <td style={stylesLocal.cell} align="right">
                    {renderPlCell(plValue)}
                </td>
                <td>
                    {formatPl(plPercent) != null && (
                        <span style={{ color: plPercent < 0 ? 'red' : 'green', fontWeight: 'bold' }}>
                            {formatPl(plPercent)}%
                        </span>
                    )}
                </td>

                <th className="cell_edit" style={stylesLocal.cell}>
                    <ReferenceModal
                        item={order}
                    />
                    <span>
                        {order.reference}{' '}
                    </span>
                </th>

                <td style={stylesLocal.cell} align="right">
                    {
                        (order.counter === 1 || order.reference) && order.roll_accum && (
                            <RollHistoryModal
                                item={order}
                                key={props.key}
                                color={order.roll_accum < 0 ? "red" : "green"}
                            />
                        )
                    }
                </td>
                <td style={stylesLocal.cell}>
                   <ActionBtnRight item={order} price={getPriceOption(order)} key={props.key} delete={() => { onClickDelete(order) }}/>
                    {/* {
                        (order.counter === 1 || order.reference) && (
                            <React.Fragment>
                                <CloseModal
                                    item={order}
                                    key={props.key}
                                    price={getPriceOption(order)}
                                />
                                {" "}
                                <RollModal
                                    item={order}
                                    key={props.key}
                                    price={getPriceOption(order)}
                                />
                                {" "}
                              
                                <span
                                    className='icon-button'
                                    onClick={() => { onClickDelete(order) }}
                                >  <div style={{ "display": "inline" }}>
                                    <Trash />
                                    </div>
                                </span>
                                

                            </React.Fragment>
                        )
                    } */}
                </td>
            </tr>
            {/* <div style={{ "display": open ? "contents" : "none" }}> */}
                {open && subOrders.map((subOrder, index) => (
                    <SubRow key={subOrder.id || index} subOrder={subOrder} order={order} />
                ))}
            {/* </div> */}
        </React.Fragment>
    )
}

Row.propTypes = {
    className: PropTypes.string
};

function mapStateToProps(reducer) {
    //console.log(reducer);
    return {

        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,

        stock: reducer.event.stock,
        option: reducer.event.option

    };
}
const mapDispatchToProps = dispatch => ({
    removeItem: (token, params) =>
        dispatch(actions.removeItem({ token, params })),
    updateReference: (token, params) =>
        dispatch(actions.updateReference({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Row);
/**
 * {order.open_at && moment(order.open_at).zone("+00:00").format('DD/MM/YYYY')}
 * {order.expire_at && moment(order.expire_at).zone("+00:00").format('DD/MM/YYYY')}
 *  {order.expire_at && (Math.trunc((new Date(order.expire_at).getTime() - Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate(), 0, 0, 0)) / (1000 * 60 * 60 * 24)))}{"-"}
 *    <GraphicModal item={order} key={props.key} />
 * 
 * 
 *  <React.Fragment>
                                                <CloseModal item={subOrder} />
                                                {" "}
                                                <RollModal item={subOrder} />
                                                {" "}
                                               
                                            </React.Fragment>
 * 
 * 
 * 
 *  open={openModalReference}
                                handleClose={handleClose}
                                handleSave={() => { handleSave(order) }}
                                handleChange={handleChange}
                                name={reference}
 *    open={openModalReference}
                                handleClose={handleClose}
                                handleSave={() => { handleSave(subOrder) }}
                                handleChange={handleChange}
                                name={reference}
 
                                size="small"
                                onClick={() => { onClickEdit(order) }}
                            >
                                <Edit />
                          


                            {
                                    order.roll_accum < 0 ?

                                        <text style={{ "color": "red" }}>
                                            {order.roll_accum}
                                        </text> :
                                        <text style={{ "color": "green" }}>
                                            {order.roll_accum}
                                        </text>
                                }
                            </RollHistoryModal>

                            {
                                            subOrder.roll_accum < 0 ?


                                                <text style={{ "color": "red" }}>
                                                    {subOrder.roll_accum}
                                                </text> :
                                                <text style={{ "color": "green" }}>
                                                    {subOrder.roll_accum}
                                                </text>
                                        }
                                    </RollHistoryModal>
 */